import { render, staticRenderFns } from "./EnvioDespachosDashBoardComponent.vue?vue&type=template&id=10a0ac96&"
import script from "./EnvioDespachosDashBoardComponent.vue?vue&type=script&lang=js&"
export * from "./EnvioDespachosDashBoardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports